module.exports = __webpack_public_path__ + "img/11000.305da870.png";